import { useState, useRef, useEffect } from "react";

export default ({
  timeLimit,
  onTimesUp
}) => {

  const timeLimitInSeconds = timeLimit * 60;

  const [timer, setTimer] = useState(Number(timeLimitInSeconds))

  const timerRef = useRef(null);

  const startTimer = () => {
    setTimer(Number(timeLimitInSeconds));
    timerRef.current = setInterval(() => setTimer((prev) => { 
      if ( prev <= 0 ) {
        return 0
      } else {
        return prev - 1 
      }
    }), 1000);
  };

  const stopTimer = () => clearInterval(timerRef.current)

  useEffect(() => {
    startTimer()
    return stopTimer // stops the timer on unmount
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (timer <= 0 ) {
      stopTimer();
      onTimesUp()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timer]);

  const formatTime = (sec) => {
    const minutes = Math.floor(sec / 60).toString().padStart(2, "0")
    const seconds = (sec % 60).toString().padStart(2, "0")
    return `${minutes}:${seconds}`
  };

    return (
      <div style={{
        position: 'absolute',
        width: '100%',
        top: '10px',
        left: '0px',
        display: 'flex',
        justifyContent: 'center'
      }}>
        <div style={{
          padding: '5px 20px',
          background: '#d2275a',
          color: '#ffffff',
          borderRadius: '10px',
          width: '150px',
          textAlign: 'center'
        }}>
          {timer > 0 ? `Time Left: ${formatTime(timer)}` : `Times Up!`}
        </div>
      </div>
    )
}